import {
  GoodsType,
  checkActUinRule,
  promShowGoodsInfo,
} from '@tencent/wphk-act-base-cgi';
import {
  ActivityCouponState,
  CouponActRelation,
  DistributionActivity,
  transformCoupons,
} from '@tencent/wphk-act-base-framework';
import { GoodItem } from '@tencent/wphk-act-base-types';
import { to } from '@tencent/wphk-base-utils';
import { checkIsNeedShowBtn } from '.';
import { ConfigCouponInfo, ItemInfo } from '../types';


export async function initActivity(actIds: string[]) {
  try {
    const distributionActivity = new DistributionActivity({
      couponActRelation: CouponActRelation.oneForOne,
      distributeActidList: actIds,
      isNeedUserCouponid: true,
    });
    // 初始化活动
    await distributionActivity.initAct();
    return distributionActivity;
  } catch (error) {
    throw error;
  }
}

/**
 * 获取券信息列表，包含DistributionActivity执行信息和GoodItem信息
 */
export async function getCouponList(activityObj: DistributionActivity | null): Promise<ItemInfo[]> {
  if (!activityObj) {
    return [];
  }
  console.log('useScanGift Activity', activityObj?.couponList ?? [], activityObj?.userCouponList ?? []);
  // 格式化券
  const formatCouponList = transformCoupons({
    couponList: activityObj?.couponList ?? [],
    userCouponList: activityObj?.userCouponList ?? [],
    // 已领取 可领取 已使用 已领完 今日已领完 已过期
    couponStateSort: [
      ActivityCouponState.expired,
      ActivityCouponState.used,
      ActivityCouponState.received,
      ActivityCouponState.totalLimit,
      ActivityCouponState.dayLimit,
      // 此处couponStateSort有优先级顺序
      // 如果用户未领取，但是命中dayLimit/totalLimit，需要优先展示limit状态
      ActivityCouponState.notReceived,
    ],
  });

  const enCouponIdList = formatCouponList.map(item => item.getCouponParams.prizeId);
  // 通过DistributionActivity查询的只是部分信息，大部分信息还要通过
  const goodsInfo = await formatShowGoodsList(enCouponIdList);
  console.log('useScanGift formatCouponList, goodsInfo', formatCouponList, goodsInfo);
  const list = formatCouponList.map((item) => {
    const findItem = goodsInfo.find(it => it.goodsEnId === item.getCouponParams.prizeId) || {};
    return {
      ...item,
      ...findItem,
      // 券UI coupon-small.vue用到
      isShowButton: checkIsNeedShowBtn(item.couponState),
      isShowUseBtn: checkIsNeedShowBtn(item.couponState),
    };
  });

  return list as unknown as ItemInfo[]; // list理论上会多一个ICashCouponInfo，但实际不会，而是跟ItemInfo一样多
}

/**
 * 领券
 */
export async function receiveCoupon({ actListid, prizeId, spId, activityObj }: {
  actListid: string; prizeId: string; spId?: string; activityObj: DistributionActivity | null
}) {
  return await activityObj?.getCoupon({ actListid, prizeId, spId });
}
/**
 * 更新券信息(重新查询)，GoodItem信息不需要更新
 */
export async function reqryCoupon(activityObj: DistributionActivity | null) {
  await activityObj?.qryCoupon();
}

/**
 * 获取并格式化promShowGoodsInfo返回
 */
const formatShowGoodsList = async (enCouponIdList: string[]): Promise<GoodItem[]> => {
  const [err, couponListConfigByGood] = await to(promShowGoodsInfo({
    goodsType: GoodsType.coupon,
    goodsIdList: enCouponIdList,
  }));
  if (err) {
    return [];
  }
  return (couponListConfigByGood.goodsArr || []).map(ele => ({
    ...ele,
    couponId: ele.goodsId,
  }));
};

/**
 * 查询黑白名单，过滤券列表
 */
export async function filterActIdsByBlackUin(checkActList: ConfigCouponInfo[]): Promise<ConfigCouponInfo[]> {
  const formatParams = checkActList.map(it => ({
    actListid: it.actIdEn,
  }));
  const [err, res] = await to(checkActUinRule({
    checkActList: formatParams,
  }));

  if (err) return [];
  // 满足条件的
  const validList = res.userActInfoList.filter(item => item.isValid).map(it => it.actListid);
  // 过滤
  return checkActList.filter(item => validList.includes(item.actIdEn));
}
